/**
 * Channel Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Online SKU with shop information
 */
export interface OnlineSkuWithShopVO { 
    /**
     * ID
     */
    id?: number;
    /**
     * Product ID
     */
    spuId?: number;
    /**
     * Product code
     */
    spuCode?: string;
    /**
     * Product name
     */
    spuName?: string;
    /**
     * Product type: 1 Physical, 2 Virtual
     */
    spuType?: number;
    /**
     * SKU ID
     */
    skuId?: number;
    /**
     * SKU code name
     */
    skuCode?: string;
    /**
     * SKU name
     */
    skuName?: string;
    /**
     * On-stock inventory
     */
    stockNum?: number;
    /**
     * Category name
     */
    categoryName?: string;
    /**
     * Warehouse type
     */
    typeCode?: string;
    /**
     * Brand name
     */
    brandName?: string;
    /**
     * Brand ID
     */
    brandId?: number;
    /**
     * Lock Number
     */
    lockNum?: number;
    /**
     * Preemption Number
     */
    preemptionNum?: number;
    /**
     * Reserved Number
     */
    reservedNum?: number;
    /**
     * Way Number
     */
    wayNum?: number;
    /**
     * Cost price
     */
    costPrice?: number;
    /**
     * Sales price
     */
    salesPrice?: number;
    /**
     * Activity price
     */
    activityPrice?: number;
    /**
     * Market price
     */
    marketPrice?: number;
    /**
     * Status
     */
    status?: OnlineSkuWithShopVO.StatusEnum;
    /**
     * Quantity available on Lazada
     */
    lazadaQuantity?: number;
    /**
     * Sellable quantity on Lazada
     */
    lazadaSellableQuantity?: number;
    /**
     * Available quantity ("Khả dụng"), computed by IMS - not self-calculated
     */
    available?: number;
    /**
     * Shop ID
     */
    shopId?: number;
    /**
     * Channel/Shop name
     */
    channelName?: string;
    /**
     * Channel type code (e.g., LAZADA, SHOPEE)
     */
    channelTypeCode?: string;
    /**
     * Channel type
     */
    channelType?: string;
}
export namespace OnlineSkuWithShopVO {
    export const StatusEnum = {
        Draft: 'DRAFT',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE',
        DraftPublished: 'DRAFT_PUBLISHED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


